import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box, Flex } from "../Box";
import { StyledFooter, StyledIconMobileContainer, StyledSocialLinks, StyledToolsContainer } from "./styles";
import LangSelector from "../LangSelector/LangSelector";
import { LogoWithTextIcon } from "../Svg";
import { ThemeSwitcher } from "../ThemeSwitcher";
var MenuItem = function(_param) {
    var items = _param.items, isDark = _param.isDark, toggleTheme = _param.toggleTheme, currentLang = _param.currentLang, langs = _param.langs, setLang = _param.setLang, cakePriceUsd = _param.cakePriceUsd, buyCakeLabel = _param.buyCakeLabel, props = _object_without_properties(_param, [
        "items",
        "isDark",
        "toggleTheme",
        "currentLang",
        "langs",
        "setLang",
        "cakePriceUsd",
        "buyCakeLabel"
    ]);
    return /*#__PURE__*/ _jsx(StyledFooter, _object_spread_props(_object_spread({
        "data-theme": "dark",
        p: [
            "40px 16px",
            null,
            "56px 40px 32px 40px"
        ]
    }, props), {
        justifyContent: "center",
        children: /*#__PURE__*/ _jsxs(Flex, {
            flexDirection: "column",
            width: [
                "100%",
                null,
                "1200px;"
            ],
            children: [
                /*#__PURE__*/ _jsx(StyledIconMobileContainer, {
                    display: [
                        "block",
                        null,
                        "none"
                    ],
                    children: /*#__PURE__*/ _jsx(LogoWithTextIcon, {
                        isDark: true,
                        width: "130px"
                    })
                }),
                /*#__PURE__*/ _jsx(Box, {
                    display: [
                        "none",
                        null,
                        "block"
                    ],
                    children: /*#__PURE__*/ _jsx(LogoWithTextIcon, {
                        isDark: true,
                        width: "160px"
                    })
                }),
                /*#__PURE__*/ _jsxs(StyledToolsContainer, {
                    "data-theme": "dark",
                    order: [
                        1,
                        null,
                        3
                    ],
                    flexDirection: [
                        "column",
                        null,
                        "row"
                    ],
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ _jsx(Flex, {
                            order: [
                                2,
                                null,
                                1
                            ],
                            mb: [
                                "24px",
                                null,
                                "0"
                            ],
                            alignItems: "center",
                            children: /*#__PURE__*/ _jsx(StyledSocialLinks, {
                                order: [
                                    2
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsxs(Flex, {
                            order: [
                                1,
                                null,
                                2
                            ],
                            mb: [
                                "24px",
                                null,
                                "0"
                            ],
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ _jsx(ThemeSwitcher, {
                                    isDark: isDark,
                                    toggleTheme: toggleTheme
                                }),
                                /*#__PURE__*/ _jsx(LangSelector, {
                                    currentLang: currentLang,
                                    langs: langs,
                                    setLang: setLang,
                                    color: "textSubtle",
                                    dropdownPosition: "top-right"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
export default MenuItem;
